export default __webpack_public_path__ + "static/media/Txt_icon.58c8a550.svg";